import "./checkbox.css.ts.vanilla.mjs";
var e = "p273__checkbox-5f36_dbf9ef1__caqn1h2", c = "p273__checkbox-5f36_dbf9ef1__caqn1h1", h = "p273__checkbox-5f36_dbf9ef1__caqn1h0";
export {
  e as checkboxStyle,
  c as darkTheme,
  h as lightTheme
};
//# sourceMappingURL=checkbox.mjs.map
